import {i18n} from '@yourcoach/i18n';

import {alert} from '../../../components/alert';

export const showAccessToMediaDevicesDeniedAlert = () =>
  alert.show({
    message: i18n.t('shared:Conference.media_access_denied_error.web'),
    title: i18n.t('shared:message.error'),
  });
